import {
  Container,
  Box,
  Typography,
  Grid,
  TextField,
  Button,
} from "@mui/material";
import HomeLayout from "/layouts/HomeLayout";
import { useTranslation } from "react-i18next";

import { validateEmail } from "utils/functions";
import i18n from "i18next";
import useWindowSize from "utils/useWindowSize";
import Image from "next/image";
import SliderTours from "components/SliderTours";
import MultiCardCarousel from "components/MultiCardCarousel";
import { getCategoriesAllList } from "context/actions/categories";
import { getProductList } from "/context/actions/product";

import { GlobalContext } from "context";

// components
import { useEffect, useState, useContext } from "react";
import WhyTravel from "components/WhyTravel";

const tabs = [
  {
    id: 1,
    title: "Дотоод аялал",
    image: "/wewew.png",
  },
];

const Content = ({}) => {
  const { state } = useContext(GlobalContext);

  const [name, setName] = useState("");
  const [success, setSuccess] = useState(false);
  const [dataCategory, setCategory] = useState([]);
  const [loading, setLoading] = useState(true); // Loader state
  const [tours, setTours] = useState([]);
  const [errors, setErrors] = useState({
    name: false,
    email: false,
    feedback: false,
  });

  useEffect(() => {
    getInitData();
  }, []);

  const getInitData = async () => {
    try {
      const resAll = await getCategoriesAllList();
      if (resAll.status === "success") setCategory(resAll.data);

      const resTours = await getProductList();
      if (resTours.status === "success") setTours(resTours.data.list);

      setLoading(false); // Set loading to false once all data is loaded
    } catch (error) {
      console.error("Error loading data:", error);
      setLoading(false); // Set loading to false in case of error
    }
  };

  return (
    <Container maxWidth={false} disableGutters={true} className="">
      <SliderTours linkData={tabs} />
      {dataCategory
        .filter((item) => item.id === 5) // зөвхөн id === 1 үлдээнэ
        .map((item, ind) => {
          const filteredTours = tours.filter(
            (tour) => tour.category_id === item.id
          );
          return (
            <Box key={ind}>
              {/* <Box className="flex items-center justify-center mt-[-25px]">
                <Box
                  className="px-4 text-center text-4xl text-[#545454] font-sans"
                  style={{
                    fontFamily: '"Merriweather", serif',
                    fontStyle: "bold",
                  }}
                >
                  {item.name}
                </Box>
              </Box> */}
              <Container maxWidth="lgs" disableGutters>
                {/* <Box className="w-full mt-2.5 text-center text-[#545454] p-3.5 text-[14px]">
                  {item.comment}
                </Box> */}
              </Container>
              {filteredTours.length > 0 && (
                <MultiCardCarousel items={filteredTours} />
              )}
            </Box>
          );
        })}
    </Container>
  );
};

Content.Layout = HomeLayout;

export default Content;
